<template>
  <BaseModal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-archivable="false"
    :is-editable="false"
    size="xl"
  >
    <template #header>
      <span v-if="idRelatedCorrespondenceMessage">{{ $t('views.excmcase.create.titleToMessage') }}</span>
      <span v-else>{{ $t('views.excmcase.create.title') }}</span>
    </template>
    <template #body>
      <create :idRelatedCorrespondenceMessage="idRelatedCorrespondenceMessage" :idContractor="idContractor" :user-data-firms="userDataFirms"></create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Create from '@/components/Dashboard/Views/excmcase/Create'
import { getUserRoles } from '@/utils/checkRoles'

export default {
  name: 'CreateCaseModal',
  components: {
    BaseModal,
    Create
  },
  props: {
    idContractor: {
      type: String,
      default: ''
    },
    idRelatedCorrespondenceMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      isVisible: 'excmcase/createModal/getIsCreateCaseModalVisible',
      userDataFirms: 'excmcase/createModal/getUserDataFirms'
    })
  },
  created () {
    this.fetchUserDataFirms(getUserRoles().id_userdata)
  },
  destroyed () {
    if (this.isVisible) {
      this.toggleModal()
    }
  },
  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'excmcase/createModal/toggleCreateCaseModal'
    }),
    ...mapActions({
      fetchUserDataFirms: 'excmcase/createModal/fetchUserDataFirms'
    })
  }
}
</script>

<style scoped>

</style>
